'use client'
import {Accordion, AccordionContent, AccordionItem, AccordionTrigger} from "@/components/ui/accordion";
import {sendGAEvent} from "@next/third-parties/google";

interface Props {
    contents: Content[]
}

interface Content {
    question: string
    answer: JSX.Element | string
}

const AccordionGroup:React.FC<Props> = ({contents}) => {

    return(
        <Accordion type="multiple">
            {
                contents.map((item, index) => {
                    return(
                        <AccordionItem key={index} value={'item-' + (index + 1)}>
                            <AccordionTrigger onClick={() => {}} className="text-base md:text-lg text-primary">{index + 1}{'. '}{item?.question || ''}</AccordionTrigger>
                            <AccordionContent className="[&>ul]:list-disc [&>ul]:list-inside text-base md:text-lg [&>p]:py-5">
                                {item?.answer}
                            </AccordionContent>
                        </AccordionItem>
                    )
                })
            }
        </Accordion>
    )
}

export default AccordionGroup